<!--  -->
<template>
<div class='bar'>
    <span v-if="!isMobile" class="back" @click="$router.go(-1)" v-show="$route.meta.length > 1">返回</span>
    <span v-if="!isMobile" class="index" @click="$router.push('/')">首页</span>
    <span v-if="isMobile" class="mback" @click="$router.go(-1)" v-show="$route.meta.length > 1"><img src="@/assets/images/mobile/back.png" alt=""></span>
    <span v-if="isMobile" class="mindex" @click="$router.push('/')"><img src="@/assets/images/mobile/home.png" alt=""></span>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import browser from '@/utils/browser.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    isMobile:browser.mobile
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    /* console.log(this.$route) */
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .bar {
        position:absolute;
        right:5vw;
        top:2vw;
        display:flex;

        span {
            display:block;
            width:6.3vw;
            height:2.3vw;
            line-height:2.5vw;
            background:#e60012;
            font-size:1vw;
            color:#fff;
            margin-left:1.5vw;
            box-sizing:border-box;
            text-align: start;
            cursor:pointer;
            &.index {
                background:#e60012 url(../../assets/images/home-icon.png)1vw center/1.25vw no-repeat;
                padding-left:2.9vw;
            }
            &.back {
                background:#e60012 url(../../assets/images/back-icon.png)1vw center/1vw no-repeat;
                padding-left:2.9vw;
            }
            &.mback {
                width:28vw;
            }
            &.mindex {
                width:28vw;
            }
        }
    }
    @media screen and (max-width:600px) {
        .bar {
            margin:4.67vw auto;
            span {
                width:28vw;
                height:auto;
                line-height:auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/bar.vue